export const OutboundCallHandling = () => {
    return <div>OutboundCallHandling</div>;
}